import {
    DEFAULT_SOCIAL_PLATFORMS,
    SOCIAL_PLATFORMS,
    type SocialPlatform,
} from "../constants/socialPlatforms"
import { type SocialLinkItem } from "../types/navigationContent"

/** Fallback list, derived from the registry so it never drifts from it. */
export function getDefaultSocialLinks(
    platforms: ReadonlyArray<SocialPlatform> = DEFAULT_SOCIAL_PLATFORMS
): SocialLinkItem[] {
    return platforms.map((platform) => ({
        platform,
        href: SOCIAL_PLATFORMS[platform].fallbackHref,
        key: platform,
    }))
}
